// EU region (ESEF annual financial reports). Registered in ../regionConfig.js.
//
// PLACEHOLDER COMMERCIALS: services and prices mirror the UKSEF structure so the region works end to end.
// Confirm the real offering, prices and VAT treatment before go-live.
export const config = {
  code: 'EU',
  sourceSite: 'digirep-eu',
  currency: 'EUR',
  supportEmail: 'hello@digitalreporting.eu',
  careEmail: 'hello@digitalreporting.eu',
  moneyPrefix: '€',
  companyIdLabel: 'Issuer identifier',
  searchProviderLabel: 'Manual issuer entry',
  phonePlaceholder: '+32 470 12 34 56',
  signupSubtitle: 'EU ESEF annual report managed services',
  primaryService: 'esef_preparation',
  accountTypes: [
    { value: 'eu_xhtml_conversion', label: 'XHTML Annual Report', subtitle: 'Annual report XHTML conversion', price: 250 },
    { value: 'eu_esef_tagging', label: 'XHTML + ESEF iXBRL Tagging', subtitle: 'ESEF-ready tagged report', price: 900 },
  ],
  optionalServices: [
    {
      id: 'esef_filing_support',
      title: 'ESEF Filing Support',
      description: 'We support filing your ESEF report with the national authority',
      price: 100,
    },
  ],
  serviceCatalog: {
    esef_preparation: { title: 'ESEF Preparation', price: 0 },
    esef_filing_support: { title: 'ESEF Filing Support', price: 100 },
  },
  delivery: {
    standard: { label: 'Standard', shortLabel: 'Standard', hours: 'standard', surcharge: 0 },
    express: { label: 'Priority (24 hours)', shortLabel: 'Priority', hours: '24h', surcharge: 250 },
  },
};

// Hostnames that identify this region and the host used for links back to it.
export const hosts = ['xbrl.digitalreporting.eu', 'preview.digitalreporting.eu'];
export const primaryHost = 'xbrl.digitalreporting.eu';
